var map = {
	"./DoubleChevron.svg": 9328,
	"./caret-up-down.svg": 9804,
	"./chevron-left-icon.svg": 7972,
	"./chevron-right-icon.svg": 3297,
	"./horse-racing/AE.svg": 4017,
	"./horse-racing/AR.svg": 4794,
	"./horse-racing/ARG.svg": 4832,
	"./horse-racing/AU.svg": 4136,
	"./horse-racing/AUS.svg": 6195,
	"./horse-racing/BH.svg": 7380,
	"./horse-racing/BHR.svg": 3569,
	"./horse-racing/BR.svg": 9203,
	"./horse-racing/BRA.svg": 5811,
	"./horse-racing/CHL.svg": 3641,
	"./horse-racing/CL.svg": 1234,
	"./horse-racing/CZ.svg": 348,
	"./horse-racing/CZE.svg": 3377,
	"./horse-racing/DE.svg": 4397,
	"./horse-racing/DEU.svg": 9971,
	"./horse-racing/FR.svg": 4792,
	"./horse-racing/FRA.svg": 1364,
	"./horse-racing/GB.svg": 4205,
	"./horse-racing/GER.svg": 2575,
	"./horse-racing/HK.svg": 5861,
	"./horse-racing/HKG.svg": 852,
	"./horse-racing/IE.svg": 3832,
	"./horse-racing/IN.svg": 7495,
	"./horse-racing/IND.svg": 7805,
	"./horse-racing/IR.svg": 328,
	"./horse-racing/IRE.svg": 9061,
	"./horse-racing/IRL.svg": 7158,
	"./horse-racing/IT.svg": 2581,
	"./horse-racing/ITA.svg": 6008,
	"./horse-racing/JP.svg": 1306,
	"./horse-racing/JPN.svg": 56,
	"./horse-racing/MU.svg": 133,
	"./horse-racing/MUS.svg": 2050,
	"./horse-racing/NO.svg": 8810,
	"./horse-racing/NOR.svg": 406,
	"./horse-racing/NZ.svg": 2818,
	"./horse-racing/NZL.svg": 6670,
	"./horse-racing/PE.svg": 4827,
	"./horse-racing/PER.svg": 5053,
	"./horse-racing/QA.svg": 1386,
	"./horse-racing/QAT.svg": 1551,
	"./horse-racing/RSA.svg": 442,
	"./horse-racing/SA.svg": 6131,
	"./horse-racing/SAU.svg": 1662,
	"./horse-racing/SE.svg": 5777,
	"./horse-racing/SIN.svg": 1572,
	"./horse-racing/SWE.svg": 2146,
	"./horse-racing/TR.svg": 8731,
	"./horse-racing/TUR.svg": 264,
	"./horse-racing/UAE.svg": 548,
	"./horse-racing/UK.svg": 7627,
	"./horse-racing/URY.svg": 8717,
	"./horse-racing/US.svg": 2996,
	"./horse-racing/USA.svg": 3547,
	"./horse-racing/UY.svg": 9622,
	"./horse-racing/ZA.svg": 4697,
	"./horse-racing/ZAF.svg": 2359,
	"./locales/de_de.svg": 5337,
	"./locales/en.svg": 4138,
	"./locales/es_419.svg": 6596,
	"./locales/es_es.svg": 8492,
	"./locales/fi_fi.svg": 9285,
	"./locales/fr_fr.svg": 7616,
	"./locales/hi_in.svg": 9252,
	"./locales/hr_hr.svg": 5443,
	"./locales/hu_hu.svg": 2761,
	"./locales/hy_am.svg": 1382,
	"./locales/in_id.svg": 1881,
	"./locales/it_it.svg": 89,
	"./locales/ja_jp.svg": 8558,
	"./locales/ka_ge.svg": 6322,
	"./locales/ko_kr.svg": 4327,
	"./locales/lt_lt.svg": 355,
	"./locales/lv_lv.svg": 7572,
	"./locales/nb_no.svg": 3575,
	"./locales/no_no.svg": 6533,
	"./locales/pl_pl.svg": 6912,
	"./locales/pt_br.svg": 1032,
	"./locales/pt_pt.svg": 5901,
	"./locales/ru_ru.svg": 4328,
	"./locales/sl_sl.svg": 7697,
	"./locales/sv_se.svg": 5555,
	"./locales/te_in.svg": 4743,
	"./locales/th_th.svg": 6920,
	"./locales/tr_tr.svg": 4567,
	"./locales/uk_ua.svg": 5764,
	"./locales/vi_vn.svg": 4675,
	"./locales/zh_cn.svg": 9282,
	"./locales/zh_tw.svg": 23,
	"./question-circle-mark.svg": 8981,
	"./question-mark.svg": 1674,
	"./reload.svg": 6939,
	"./running-ball.png": 682,
	"./saddlecloths-sprite.gif": 5234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;